import { render, staticRenderFns } from "./TeamRecordsTable.vue?vue&type=template&id=ba5a25d8&scoped=true"
import script from "./TeamRecordsTable.vue?vue&type=script&lang=ts"
export * from "./TeamRecordsTable.vue?vue&type=script&lang=ts"
import style0 from "./TeamRecordsTable.vue?vue&type=style&index=0&id=ba5a25d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba5a25d8",
  null
  
)

export default component.exports